import React from "react";
import "./Steps.css";
import Stepper from 'react-stepper-horizontal'

export default function Steps({
    activeTab = "account",
}) {
    
    const steps = [
        {title: 'Order Decals'}, 
        //{title: 'Share Your Story'}, 
        {title: 'Download Stamps'}, 
        {title: 'Customize Your Images'}
    ];

    function getActiveStep() {
        if (activeTab === "sticker") {
            return 0;
        } /*else if (activeTab === "story") {
            return 1;
        }*/ else if (activeTab === "stamps") {
            return 1;
        } else if (activeTab === "socialcontent") {
            return 2;
        }
    }

    return (
        <div className="Steps">
            <Stepper steps={steps} activeStep={getActiveStep()} completeColor={"#19ac71"} activeColor={"#19ac71"} />
        </div>
    );
}
    